<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                        <div>
                            <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                        </div>
                        <div>Cette interface vous permet de rembourser les inscriptions en masse. Il y a actuellement
                            <b>{{
                                count_match_query }}</b> inscriptions à rembourser. Affichage de 100 inscriptions par
                            page.
                        </div>
                        <div class="d-flex justify-space-between align-center ga-2">
                            <SportipsButton icon="mdi-currency-eur" chevron @click="launch_bulk_refunds()">Lancer
                                les remboursements</SportipsButton>


                        </div>

                        <div class="spo-card pa-2 rounded bordered " v-for="inscription in inscriptions"
                            :key="inscription.id">
                            <div class="d-flex justify-space-between">
                                <div>
                                    <div class="font-weight-bold">{{ inscription.nom }} {{ inscription.prenom }}</div>
                                    <div>{{ inscription.course.nom }}</div>

                                    <SportipsButton icon="mdi-account" chevron
                                        @click="access_fiche_inscription(inscription)">Accéder à la fiche de
                                        l'inscription</SportipsButton>
                                    <div>{{ inscription.refund_request.details }}</div>

                                </div>
                                <div class="d-flex flex-column text-center">
                                    <div>Montant à rembourser</div>
                                    <div class="font-weight-bold text-h6">
                                        {{ inscription.refund_request.amount_to_refund }}€
                                    </div>
                                    <SportipsButton icon="mdi-currency-eur" chevron @click="launch_refund(inscription)">
                                        Rembourser</SportipsButton>
                                </div>
                            </div>
                            <v-alert v-if="inscription.refund_request.error" density="compact" type="error"
                                variant="elevated" elevation="0">{{ inscription.refund_request.error
                                }}</v-alert>
                            <div v-if="inscription.refund_request.response">
                                <v-alert v-if="!inscription.refund_request.response.refund_possible" density="compact"
                                    type="error" variant="elevated" elevation="0">Le remboursement n'a pas pu être
                                    effectuée. Les fonds sur la commande associée à cette inscription sont
                                    insuffisants. Montant remboursé: {{
                                        inscription.refund_request.response.amount_refunded }}€ | Montant restant à
                                    rembourser: {{ inscription.refund_request.response.amount_not_refunded }}€</v-alert>

                                <div v-else>
                                    <v-alert
                                        v-if="inscription.refund_request.response.amount_to_refund != inscription.refund_request.response.amount_refunded"
                                        density="compact" type="error" variant="elevated" elevation="0">Le remboursement
                                        n'a pas pu être effectué intégralement. Le remboursement d'une des transactions
                                        a
                                        echoué (problème de communication banque...). Montant remboursé: {{
                                            inscription.refund_request.response.amount_refunded }}€ | Montant restant à
                                        rembourser: {{ inscription.refund_request.response.amount_not_refunded
                                        }}€</v-alert>
                                    <v-alert v-else density="compact" type="success" variant="elevated" elevation="0">Le
                                        remboursement a été effectué avec succès. Montant remboursé: {{
                                            inscription.refund_request.response.amount_refunded }}€</v-alert>
                                </div>
                            </div>



                        </div>
                        <!-- 
                        <div class="d-flex justify-space-between align-center ga-2">
                            <SportipsButton icon="mdi-currency-eur" chevron @click="launch_charge_commandes()">Lancer
                                l'encaissement automatique</SportipsButton>
                            <v-text-field v-model="limit" type="number" min="1" max="1000"
                                label="Nombre de commandes à encaisser" density="compact" hide-details></v-text-field>
                            <div>
                                <div>Succès: {{ stats.success }}</div>
                                <div>Erreur: {{ stats.error }}</div>
                                <div>Total: {{ stats.total }}</div>
                            </div>
                        </div>

                        <div v-for="commande in pendings_commandes" :key="commande.id"
                            class="spo-card pa-2 rounded bordered">
                            <div class="d-flex justify-space-between">
                                <div>
                                    <div class="font-weight-bold">Commande n°{{ commande.uuid }}</div>
                                    <div class="text-subtitle-1">{{ commande.prix_total }}€ | Validée le {{
                                        $moment(commande.created_at).format("DD/MM/YYYY à HH:mm") }}</div>
                                </div>
                                <div>
                                    <v-chip :color="get_color_status(commande.status)" variant="elevated" elevation="0">
                                        {{ commande.status }}
                                    </v-chip>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AdminService from "@/services/admin.service";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Inscription_Refund from "@/classes/Refund/Inscription_Refund.class.js";
export default {
    data() {
        return {
            inscriptions: [],
            count_match_query: 0,

            refunds_list: [],
        }
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        access_fiche_inscription(inscription) {
            //ouvrir une nouvelle fenêtre avec la fiche de l'inscription
            this.$router.push({ name: 'EditInscriptionAdmin', params: { id_inscription: inscription.id } });
        },
        async launch_refund(inscription) {
            inscription.refund_inited = true;
            await inscription.refund_request.proceedToRefund();

        },
        async launch_bulk_refunds() {
            for (let i = 0; i < this.inscriptions.length; i++) {
                if (this.inscriptions[i].refund_inited) continue;
                this.inscriptions[i].refund_inited = true;
                await this.inscriptions[i].refund_request.proceedToRefund();
            }
        },
        build_refunds_list() {

            for (let i = 0; i < this.inscriptions.length; i++) {
                let inscription_refund = new Inscription_Refund();
                inscription_refund.init(this.inscriptions[i], this.mainStore.module.base);
                this.inscriptions[i].refund_request = inscription_refund;
            }
        },
        async fetchInscriptions() {
            this.inscriptions = [];
            let request = await AdminService.getListInscriptionsBulkRefunds(this.mainStore.module.id);
            if (request) {
                this.inscriptions = request.list;
                this.count_match_query = request.count_match_query;
                this.build_refunds_list();
            }
        }
    },
    async created() {
        await this.fetchInscriptions();
    }
}
</script>

<style lang="scss" scoped></style>